import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { HealthBarComponent } from "./components/HealthBarComponent";
import { BackpackCaseComponent } from "./components/BackpackCaseComponent";
import { PageBackpackComponent } from "./components/PageBackpackComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { GameSoundComponent } from "./components/GameSoundComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("health-bar", HealthBarComponent);
window.customElements.define("game-backpack", BackpackCaseComponent);
window.customElements.define("game-page-backpack", PageBackpackComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-sound", GameSoundComponent);
